import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Allergen(props) {
    const { allergen, total, index } = props;

    const { t } = useTranslation();

    return (
        <span className="allergen font-bold">{allergen.name}{(Boolean(Number(total - index - 1))) ? ", " : null}</span>
    );
}
